import React from 'react';
import styles from './breadcrumb.module.css';

const Breadcrumb = ({ pathItems }) => {
  return (
    <nav aria-label="breadcrumb" className={styles.breadcrumbNav}>
      <ol className={styles.breadcrumbList}>
        {pathItems.map((item, index) => {
          const isLast = index === pathItems.length - 1;

          return (
            <li key={index} className={styles.breadcrumbItem}>
              {isLast ? (
                <span className={styles.font}>{item.name}</span>
              ) : (
                <a href={item.url} className={styles.font}>
                  {item.name}
                </a>
              )}
              {!isLast && <span className={styles.separator}> &gt; </span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
